import React, { createElement } from 'react';
import { X, Download, ZoomIn, ZoomOut } from 'lucide-react';
interface PdfViewerModalProps {
  isOpen: boolean;
  onClose: () => void;
  pdfUrl: string;
  fileName: string;
}
export function PdfViewerModal({
  isOpen,
  onClose,
  pdfUrl,
  fileName
}: PdfViewerModalProps) {
  if (!isOpen) return null;
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = fileName;
    link.click();
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center" data-id="element-261">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black bg-opacity-75" onClick={onClose} data-id="element-262" />

      {/* Modal */}
      <div className="relative w-full h-full max-w-7xl max-h-screen m-4 bg-white rounded-lg shadow-2xl flex flex-col" data-id="element-263">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-50" data-id="element-264">
          <div className="flex-1" data-id="element-265">
            <h2 className="text-lg font-semibold text-gray-900 truncate" data-id="element-266">
              {fileName}
            </h2>
          </div>

          <div className="flex items-center gap-2" data-id="element-267">
            <button onClick={handleDownload} className="p-2 text-gray-600 hover:bg-gray-200 rounded-lg transition-colors" title="Scarica PDF" data-id="element-268">
              <Download size={20} data-id="element-269" />
            </button>
            <button onClick={onClose} className="p-2 text-gray-600 hover:bg-gray-200 rounded-lg transition-colors" title="Chiudi" data-id="element-270">
              <X size={20} data-id="element-271" />
            </button>
          </div>
        </div>

        {/* PDF Viewer */}
        <div className="flex-1 overflow-hidden bg-gray-100" data-id="element-272">
          <iframe src={pdfUrl} className="w-full h-full" title={fileName} data-id="element-273" />
        </div>
      </div>
    </div>;
}